import { Button } from "@novaescola/eva-react-v2/lib/Button";
import Cookies from "js-cookie";
import * as React from "react";
import { meuPerfilApi } from "../../api/meu-perfil/meu-perfil.api";


const ActionsButtons = ({ url, isPDFLink, complementoCadastroEventLabel, contentId, contentTitle, contentToSave }) => {
  // TODO: refactor to use CSS media queries with SASS
  const [isDesktop, setIsDesktop] = React.useState(false);

  const complementoCadastroSettings = async (buttonName) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + 60 * 60 * 1000);
    const cookiesOptions = {
      domain: ".novaescola.org.br",
      expires,
      path: "/",
    };

    if (complementoCadastroEventLabel) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "complete_registration",
        label: `JORNALISMO: ${complementoCadastroEventLabel.replace("BUTTON_NAME", buttonName)}`,
      });
    } else {
      Cookies.set(
        "ane_complemento_cadastro_event",
        JSON.stringify({ category: 'JORNALISMO', label: `botão ${buttonName}` }),
        cookiesOptions
      );
    }

    if (isPDFLink) {
      Cookies.set(
        "ane_download_content_url",
        url,
        cookiesOptions
      );

      const bearer = Cookies.get("Bearer");
      try {
        if (buttonName === "IMPRIMIR") {
          contentToSave.printedAt = new Date();
          await meuPerfilApi.savePrintContent(bearer, contentToSave);
        } else if (buttonName === "BAIXAR PDF") {
          contentToSave.downloadedAt = new Date();
          await meuPerfilApi.saveDownloadContent(bearer, contentToSave);
          await handleDownload();
          window.location.href = "https://novaescola.org.br/sucesso-download"
        }
      } catch (error) {
        console.error('error while saving print/download',error)
      }
    }
  }

  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = url.split("/")[url.split("/").length - 1];
      link.click();

      // Cleanup
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('Erro ao baixar o PDF:', error);
    }
  };

  React.useEffect(() => {
    setIsDesktop(window.innerWidth > 768);
    const listener = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, []);

  return (
    <div className="actions-buttons eva-margin-bottom-4">
      <Button
        size="medium"
        fill="emptied"
        className="eva-mb-06"
        asChild
      >
        <a
          href={
            isPDFLink ? "https://novaescola.org.br/sucesso-impressao" : url
          }
          target="_self"
          rel="noreferrer"
          className="eva-btn-full"
          type="button"
          data-track="Nova página de conteúdo - botão imprimir"
          onClick={() => {
            if (contentId && contentTitle) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "print",
                item_id: contentId,
                item_name: contentTitle,
                item_category: "conteudo",
              });
            }

            complementoCadastroSettings("IMPRIMIR");
          }}
        >
          <i className="fal fa-print icon-left"></i>Imprimir
        </a>
      </Button>

      <Button
        size="medium"
        fill="emptied"
        asChild
      >
        <a
          href={
            isPDFLink ? "https://novaescola.org.br/sucesso-download" : url
          }
          target="_self"
          rel="noreferrer"
          className="eva-btn-full"
          type="button"
          data-track="Nova página de conteúdo - botão baixar PDF"
          onClick={(event) => {
            if (isPDFLink) event.preventDefault();

            if (contentId && contentTitle) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "download",
                label: "pdf",
                item_id: contentId,
                item_name: contentTitle,
                item_category: "conteudo",
              });
            }

            complementoCadastroSettings("BAIXAR PDF");
          }}
        >
          <i className="far fa-download icon-left"></i>Baixar PDF
        </a>
      </Button>
    </div>
  );
};

export default ActionsButtons;
